import React from 'react'
import styled from '@emotion/styled'

const ListBox = styled.p`
  margin-top: 4px;
  color: #bf1650;

  &::before {
    display: inline;
    content: '⚠ ';
  }
`
// 错误提示组件
// show: 是否显示 errorMessage 具体内容
const ErrorTip = ({ errorMessage }) => {
  return <ListBox>{errorMessage}</ListBox>
}

export default ErrorTip
